'use strict'

import { QueryClient, onlineManager } from '@tanstack/react-query'

// FIX: React Query's default networkMode is 'online', which means it pauses
// all queries the moment navigator.onLine is false. On tab switch, some
// browsers (especially mobile) briefly report offline when the tab regains
// focus. This causes every query to freeze in a loading state and stay there
// until the browser's online event fires — which can take several seconds.
//
// Setting networkMode: 'always' tells React Query to fire queries regardless
// of what the browser's online manager reports. Our WebSocket already handles
// real connectivity (status indicator, sync_website re-emit on reconnect).
// We don't need the browser's coarse online/offline signal on top of that.
onlineManager.setOnline(true)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime:               5 * 60 * 1000,
      retry:                1,
      staleTime:            30_000,
      refetchOnWindowFocus: false,
      // Never pause queries due to browser online/offline events
      networkMode:          'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
})
